import { TableCellTypography } from '@aibees/shared/components';
import { classnames } from '@aibees/shared/utils';
import { memo } from 'react';
import * as Styled from './styles';
import * as SX from './sx';
import type { MemberCreditUsedProps as Props } from './types';

export const MemberCreditUsed = memo(({ className, member }: Props) => {
  const usedCredits = member.creditUsed;
  const displayValue = usedCredits != null ? usedCredits : 'N/A';
  const isNa = usedCredits == null;

  return (
    <Styled.Wrapper
      className={classnames('MemberCreditUsed', className)}
      sx={SX.root}
    >
      <TableCellTypography
        variant="body3"
        fontWeight={400}
        color={isNa ? 'grey.400' : 'grey.700'}
        item={displayValue}
      />
    </Styled.Wrapper>
  );
});

MemberCreditUsed.displayName = 'MemberCreditUsed';
